import { ReactElement } from 'react';

import { Device } from '@device/Device';
import { getDevice } from '@device/getDevice';
import useIsMounted from '@utils/hooks/isMounted';

interface DeviceAdvertsWrapperProps {
  device: Device;
  children: ReactElement;
}

const DeviceAdvertWrapper: React.FC<DeviceAdvertsWrapperProps> = ({
  children,
  device,
}) => {
  const isMounted = useIsMounted();

  if (isMounted && device === getDevice()) {
    return children;
  }

  return null;
};

export default DeviceAdvertWrapper;
